import { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Button, Divider, Grid, List, ListItemButton, Stack, Typography, Box, FormControl, Select, MenuItem, Checkbox, ListItemText, Slider, Switch, FormControlLabel } from "@mui/material";
import _ from "lodash";
import { useAuthorization, isParatus, isCnhOrgId } from "../../../utils/util";
import { getAvailableProductsForAccount, assignCustomPlan, updateNonAdminPermissions, getNonAdminPermissions, getParentDP, getRouterConfigVisibility, setRouterConfigVisibility, createDPOAccount, updateDPOAccount, getDPOAccount, ACTION_TYPES, verifyDPOAccount } from "../slice";
import OrgSelectioMultipleCheck from "./OrgSelectioMultipleCheck";
import CommonModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import DpoAccountTab from "./DpoAccountTab";
import OrgSelection from "../../OrgSelection";

type DpoAccountTabRef = {
    getPayload: () => any;
    isValid: () => boolean;
};

const EditActionsPopup = (props) => {
    const { loading, open, setOpen, confirmDialog, setConfirmDialog, location, authReducer, dpoAccountInfo, dpIds, routerConfigVisibility, settingRouterConfigVisibility, allNonAdminPermissions, creatingDPOAccount, dpoVerificationStatus, updatingDPOAccount, gettingDPOAccount, updateNonAdminPermissions, createDPOAccount, updateDPOAccount, verifyDPOAccount, getDPOAccount, getNonAdminPermissions, getParentDP, parentDp, setRouterConfigVisibility, getRouterConfigVisibility } = props;
    const { isAdmin } = useAuthorization();
    const dispatch = useDispatch();
    const dpoTabRef = useRef<DpoAccountTabRef | null>(null);
    const isEditMode = !_.isEmpty(dpoAccountInfo);
    const [dpoPayload, setDpoPayload] = useState<any>(null);
    const [isDpoValid, setIsDpoValid] = useState(false);
    const [selectedDp, setSelectedDp] = useState<any>([]);
    const CNH_ONLY_PERM_KEYS = ["serviceLinePackage", "userTerminalPackage", "devices", "quotas"];
    const [selectedDpAccount, setSelectedDpAccount] = useState<any>({});
    const deviceActionsList = [  isAdmin ? "CONFIGURE" : null, isParatus(authReducer?.selectedOu?.id) && "ACCOUNT", "ROUTER"].filter(action => action);
    const [selectedRole, setSelectedRole] = useState("starlinkAdminAccess");
    const [verifyPopup, setVerifyPopup] = useState<any>({open: false, data: null})
    const [toggleRouter, setToggleRouter] = useState(true)
    const [filteredDpIds, setFilteredDpIds] = useState(dpIds)

    useEffect(() => {
        setToggleRouter(routerConfigVisibility !== 'disabled');
    }, [routerConfigVisibility, open])
    const [permissions, setPermissions] = useState({
        starlinkAdminAccess: {
            mobilePriority: { allowed: false, enabled: true },
            pauseServicePlans: { allowed: false, enabled: true },
            servicePlan: { allowed: false, enabled: true },
            terminals: { allowed: false, enabled: true },
            publicIp: { allowed: false, enabled: true },
        },
        starlinkFullAccess: {
            mobilePriority: { allowed: false, enabled: true },
            pauseServicePlans: { allowed: false, enabled: true },
            servicePlan: { allowed: false, enabled: true },
            terminals: { allowed: false, enabled: true },
            publicIp: { allowed: false, enabled: true },
        },
        starlinkAccess: {
            mobilePriority: { allowed: false, enabled: true },
            pauseServicePlans: { allowed: false, enabled: true },
            servicePlan: { allowed: false, enabled: true },
            terminals: { allowed: false, enabled: true },
            publicIp: { allowed: false, enabled: true },
        }
    });


    const handleRoleChange = (event) => {
        setSelectedRole(event.target.value);
    };

    const handleToggle = (key) => {
        setPermissions((prevPermissions) => ({
            ...prevPermissions,
            [selectedRole]: {
                ...prevPermissions[selectedRole],
                [key]: {
                    ...prevPermissions[selectedRole][key], // Keep `enabled` unchanged
                    allowed: !prevPermissions[selectedRole][key].allowed, // Toggle `allowed`
                }
            }
        }));
    };

    useEffect(() => {
        if (!_.isEmpty(allNonAdminPermissions)) {
            setPermissions(allNonAdminPermissions)
        }
    }, [allNonAdminPermissions])

    useEffect(() => {
        if (allNonAdminPermissions) {

            if (!_.isEmpty(allNonAdminPermissions)) {

            } else {

            }
        }
    }, [allNonAdminPermissions])

    const getIdNameForList = (action) => {
        if (action == "CONFIGURE") {
            if (isAdmin) {
                return 'actionType-enabled';
            }
        }
        if (action == "ACCOUNT") {
            return 'actionType-enabled';
        }
         if (action == "ROUTER") {
            return 'actionType-enabled';
        }
        return 'actionType-disabled';
    }

    const getDefaultActionType = (list) => {
        const actionTypes = list.map(action => {
            if (getIdNameForList(action) == 'actionType-enabled') {
                return action;
            } else {
                return '';
            }
        })

        return actionTypes?.filter(action => action != '')?.length > 0 ? actionTypes?.filter(action => action != '')?.[0] : deviceActionsList[0];
    }

    const [selectedAction, setSelectedAction] = useState(getDefaultActionType(deviceActionsList));


    const updateActionValues = (action) => {
        switch (action) {
            case "CONFIGURE": {
                break;
            }
            case "ACCOUNT": {
                break;
            }
             case "ROUTER": {
                break;
            }

            default: setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false })
        }
    }

    useEffect(() => {
        updateActionValues(selectedAction);
        if (selectedAction === "ACCOUNT" && dpoTabRef.current) {
            setIsDpoValid(dpoTabRef.current.isValid());
        }
    }, [selectedAction, dpoAccountInfo]);

    const handleChangeActionType = (actionType) => {
        setSelectedAction(actionType);
        selectedAction != actionType && setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
    }

    const handleConfirmClick = () => {
        confirmDialog.onConfirm();
    }

    const handleClose = () => {
        setSelectedAction(getDefaultActionType(deviceActionsList))
        setOpen(false);
        dispatch({ type: ACTION_TYPES.GET_DPO_ACCOUNT, payload: {} })
        setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
    }
    
    const handleSavePermissions = async () => {
        if (selectedAction === "CONFIGURE") {
            const formattedPermissions = Object.fromEntries(Object.entries(permissions).map(([role, perms]) => [role, Object.fromEntries(Object.entries(perms).map(([perm, { allowed }]) => [perm, allowed]))]));

            let params = {
                data: { dpIds: selectedDp?.map((sl) => sl.id) || [], permissions: formattedPermissions }
            };

            await updateNonAdminPermissions(params);
             handleClose();
           
        } else if (selectedAction === "ACCOUNT") {
            if (!isDpoValid || !dpoPayload) return;
             verifyDPOAccount(dpoPayload);
           
        }else if (selectedAction === "ROUTER") {
            setRouterConfigVisibility({
                dpIds: filteredDpIds ,
                visibility: toggleRouter ? 'enabled' : 'disabled'
            });

        }
        
    };

    useEffect(() => {
        if (!_.isEmpty(dpoVerificationStatus)) {
            setVerifyPopup({ open: true, data: dpoVerificationStatus })
        }

    }, [dpoVerificationStatus])

    const handleSaveAccountInfo = () => {
        if (!isDpoValid || !dpoPayload) return;
        if (isEditMode) {
            updateDPOAccount(dpoPayload);
        } else {
            createDPOAccount(dpoPayload);
        }
        handleClose();
        setVerifyPopup({ open: false, data: null })
        dispatch({ type: ACTION_TYPES.GET_VERIFY_DPO_ACCOUNT, payload: {} })
    }

    const handleCloseVerifyPopup = () => {
        setVerifyPopup({ open: false, data: null })
        dispatch({ type: ACTION_TYPES.GET_VERIFY_DPO_ACCOUNT, payload: {} })
    }

    useEffect(() => {
        setSelectedDp([{ id: authReducer?.selectedOu?.id, name: authReducer?.selectedOu?.name }])
        setSelectedDpAccount({ id: authReducer?.selectedOu?.id, name: authReducer?.selectedOu?.name })
        getParentDP({ dpId: authReducer?.selectedOu?.id })
        if(open) getDPOAccount({ dpId: authReducer?.selectedOu?.id })
        getRouterConfigVisibility({ dpId: selectedDpAccount?.id })
    }, [open])

    useEffect(() => {
        if (!_.isEmpty(parentDp) && selectedDp?.length > 0) {
            getNonAdminPermissions({ dpId: selectedDp[0]?.id, parentDpId: parentDp?.parentOUName === "root" ? 'DP-0001' : parentDp?.parentOUId })
        }
    }, [parentDp])


    const handleChangeDp = async (ou: any) => {
        setSelectedDp(ou)
        if (!_.isEmpty(parentDp) && ou?.length > 0) {
            getNonAdminPermissions({ dpId: ou[0]?.id, parentDpId: parentDp?.parentOUName === "root" ? 'DP-0001' : parentDp?.parentOUId })
        }
    }

     const getChildren = (dpIds, dps) => {
        for (let i = 0; i < dps?.length; i++) {
            let id = dps[i]?.id;
            dpIds.push(id);
            if (dps[i].hasOwnProperty('_childern') && dps[i]['_childern']?.length > 0) {
                getChildren(dpIds, dps[i]['_childern'])
            }
        }
    }

     const handleChangeDpAccount = async (ou: any) => {
        setSelectedDpAccount(ou)

        const parentDpId = ou?.id;
            const dpIds = authReducer?.parentDpAndSubDpList;
            if (dpIds.hasOwnProperty(parentDpId)) {
                const _dpIds: any = [];
                _dpIds.push(parentDpId);
                getChildren(_dpIds, dpIds[parentDpId]);
               setFilteredDpIds(_dpIds.filter(id => id !== ""))
            }

          dispatch({ type: ACTION_TYPES.GET_DPO_ACCOUNT, payload: {} })
         getDPOAccount({ dpId: ou?.id })
         getRouterConfigVisibility({ dpId: ou?.id })
    }

    return (
        <div className="Form">
            <CommonModal
                open={open}
                onClose={handleClose}
                onSave={handleSavePermissions}
                title="Permissions"
                saveText={selectedAction === "ACCOUNT" ? isEditMode ? "Verify" : "Verify" : "Save"}
                cancelText="Cancel"
                width="800px"
                maxWidth="800px"
                showOnlineOffline={false}
                showSyncStatus={false}
                disableSave={(selectedAction === "ACCOUNT" && !isDpoValid) || (selectedAction === "ROUTER" && (settingRouterConfigVisibility || !selectedDpAccount?.id))}
                showLoader={creatingDPOAccount || updatingDPOAccount || gettingDPOAccount}
            >
                <div>
                    <Box className='str-permission-pad'>
                        <Grid container spacing={1}>
                            <Grid xs={3} className="menuScroll device-border-right deployed-device-list" item>
                                <Grid className="device-data-body actions-device-data-body">
                                    <List>
                                        {deviceActionsList && deviceActionsList.map((identifier, index) => {
                                            return <ListItemButton id={getIdNameForList(identifier)} className='status-lists'
                                                style={identifier === selectedAction ? { background: 'rgba(244, 245, 250, 1)' } : { background: '#fff' }}
                                                key={`device-${index}`}
                                                selected={identifier === selectedAction}
                                                onClick={() => getIdNameForList(identifier) == 'actionType-enabled' && handleChangeActionType(identifier)}>
                                                <Typography className={identifier === selectedAction ? "font-status-pop-up selectedAction" : "font-status-pop-up NotselectedAction"}>{identifier}</Typography>
                                            </ListItemButton>
                                        })}
                                    </List>
                                </Grid>
                            </Grid>
                            <Grid item xs={9} className="menuScroll starlinkAdmin-edit-actions-cont" style={{ minHeight: "250px" }}>
                                <Grid className=" edit-actions-data-body">
                                    <Stack className="sub-tab-parent" direction="column" spacing={1}>
                                        {confirmDialog.isOpen && <div className="custom_confirm_dialog_sub_title edit-actions-subTitle">
                                            {confirmDialog.subTitle}
                                            <div className="edit-actions-confirm-btns">
                                                <Divider className="confirm-dialogue-new-divider" />
                                                <div className="confirm-dialogue-new-btns">
                                                    <Button className="confirm-dialogue-cancel" onClick={handleClose}> Cancel </Button>
                                                    <Button className="confirm-dialogue-proceed" onClick={() => handleConfirmClick()}> Proceed </Button>
                                                </div>
                                            </div>
                                        </div>}
                                        {selectedAction == "CONFIGURE" && getIdNameForList(selectedAction) == 'actionType-enabled' &&
                                            <div>
                                                <Box className="starlink-serviceAccount-details-container">

                                                    <Box className="starlink-serviceAccount-details-row">
                                                        <Box className="starlink-serviceAccount-details-heading">Sub Organization </Box>
                                                        <Grid style={{ width: "450px" }} className="configuration-form-build">
                                                            <OrgSelectioMultipleCheck  label="Select Organizations"
                                                                value={Array.isArray(selectedDp) ? selectedDp : []}
                                                                onChange={handleChangeDp}
                                                                disabled={false}
                                                            />
                                                        </Grid>
                                                    </Box>
                                                    <Box className="starlink-serviceAccount-details-row">
                                                        <Box className="starlink-serviceAccount-details-heading">Role</Box>
                                                        <Grid className="configuration-form-build">
                                                            <FormControl>
                                                                <Select
                                                                    id="mobile-priority-select"
                                                                    value={selectedRole} onChange={handleRoleChange}
                                                                    size="small"
                                                                    style={{ width: "351px" }}
                                                                >
                                                                    {Object.keys(permissions)?.map((role) => (
                                                                        <MenuItem key={role} value={role}>
                                                                            {role.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                    </Box>

                                                    {Object.keys(permissions[selectedRole])
                                                        ?.filter((perm) => !CNH_ONLY_PERM_KEYS.includes(perm) || isCnhOrgId(selectedDp?.[0]?.id))
                                                        ?.map((perm) => (
                                                        <Box key={perm} className="starlink-serviceAccount-details-row">
                                                            <Box className="starlink-serviceAccount-details-heading">
                                                                {perm === "mobilePriority" ? "Mobile Priority" :
                                                                    perm === "pauseServicePlans" ? "Pause Resume Service Line" :
                                                                        perm === "servicePlan" ? "Update Service Plan" :
                                                                            perm === "terminals" ? "Manage Terminals" :
                                                                                perm === "publicIp" ? "Public IP Access" :
                                                                                    perm === "serviceLinePackage" ? "Service Line Package" :
                                                                                        perm === "userTerminalPackage" ? "User Terminal Package" :
                                                                                            perm === "devices" ? "Devices" :
                                                                                                perm === "quotas" ? "Quotas" : perm}
                                                            </Box>

                                                            <Grid container className="starlink-account-service-permissions-actions-td">
                                                                <FormControlLabel
                                                                    control={
                                                                        <Switch
                                                                            checked={permissions[selectedRole][perm].allowed}
                                                                            disabled={!permissions[selectedRole][perm].enabled} // Only disable if `enabled` is false
                                                                            onChange={() => handleToggle(perm)}
                                                                            color="primary"
                                                                            inputProps={{ "aria-label": "controlled" }}
                                                                        />
                                                                    }
                                                                    labelPlacement="start"
                                                                    label={permissions[selectedRole][perm].allowed ? "Allowed" : "Not Allowed"}
                                                                />
                                                            </Grid>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </div>
                                        }

                                        {selectedAction == "ACCOUNT" && (
                                            <DpoAccountTab
                                                selectedDp={selectedDpAccount}
                                                handleChangeDp={handleChangeDpAccount}
                                                dpoAccountInfo={dpoAccountInfo}
                                                onChange={(payload, valid) => {
                                                    setDpoPayload(payload);
                                                    setIsDpoValid(valid);
                                                }}
                                            />                                            
                                            )}

                                            {selectedAction == "ROUTER" && (
                                            <Grid container direction="column" className="starlink-serviceAccount-details-container">

                                                <Box className="starlink-serviceAccount-details-row">
                                                        <Box className="starlink-serviceAccount-details-heading">
                                                            Organization
                                                        </Box>
                                                    <OrgSelection  value={selectedDpAccount} onChange={handleChangeDpAccount} disabled={false} />
                                                </Box>
                                                <Box className="starlink-serviceAccount-details-row">
                                                        <Box className="starlink-serviceAccount-details-heading">
                                                            Config Library Visibility
                                                        </Box>
                                                        <Grid container className="starlink-account-service-permissions-actions-td">
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={toggleRouter}
                                                                        onChange={() => {
                                                                            const newVal = !toggleRouter;
                                                                            setToggleRouter(newVal);
                                                                        }}
                                                                        color="primary"
                                                                        inputProps={{ "aria-label": "controlled" }}
                                                                    />
                                                                }
                                                                labelPlacement="start"
                                                                label={""}
                                                            />
                                                        </Grid>
                                                    </Box>
                                           </Grid>

                                        )}

                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </CommonModal>

            <CommonModal
                open={verifyPopup?.open}
                onClose={handleCloseVerifyPopup}
                onSave={handleSaveAccountInfo}
                title="Account Verification"
                saveText={"Save"}
                cancelText="Cancel"
                width="400px"
                maxWidth="400px"
                disableSave={verifyPopup?.data?.message !== "ACCOUNT_IS_VALID"}
                showOnlineOffline={false}
                showSyncStatus={false}
            >
                <Grid container className="dpo-topup-payment-wrapper">
                    <div>
                        <Typography className="sub-text">
                            {verifyPopup?.data?.message === "ACCOUNT_IS_VALID" ? "Account verification completed successfully." : "We couldn’t verify the account. Please review the details and try again."}
                        </Typography>

                         <Typography className="sub-text">
                            {verifyPopup?.data?.message !== "ACCOUNT_IS_VALID" && verifyPopup?.data?.message }
                        </Typography>
                    </div>
                </Grid>

            </CommonModal>
        </div>
    )
}

const mapStateToProps = (state) => ({
    loading: state.starlinkAdmin.subcribingServiceLine,
    authReducer: state.authReducer,
    parentDp: state.starlinkAdmin.parentDp,
    allNonAdminPermissions: state.starlinkAdmin.allNonAdminPermissions,
    dpoAccountInfo: state.starlinkAdmin.dpoAccountInfo,
    creatingDPOAccount:state.starlinkAdmin.creatingDPOAccount,
    updatingDPOAccount:state.starlinkAdmin.updatingDPOAccount,
    gettingDPOAccount:state.starlinkAdmin.gettingDPOAccount,
    dpoVerificationStatus:state.starlinkAdmin.dpoVerificationStatus,
    routerConfigVisibility: state.starlinkAdmin.routerConfigVisibility,
    newSummaryServiceAccount: state?.authReducer?.newSummaryServiceAccount,
    settingRouterConfigVisibility: state.starlinkAdmin.settingRouterConfigVisibility,
     dpIds: state.starlinkCloud.dpIds, 
});

export default withRouter(
    connect(mapStateToProps, { getAvailableProductsForAccount, assignCustomPlan, updateNonAdminPermissions, getNonAdminPermissions, getParentDP, updateDPOAccount, verifyDPOAccount, createDPOAccount, getDPOAccount, setRouterConfigVisibility, getRouterConfigVisibility })(EditActionsPopup)
);